<span class="text-3xl">{{ 'cases.title' | translate }}</span>

<p>{{ 'cases.description' | translate }}</p>
<button
  kendoButton
  themeColor="primary"
  class="uppercase"
  maximizerShowcaseBookDemo
>
  {{ 'cases.button.action' | translate }}
</button>
